import { Directive, TemplateRef } from '@angular/core';
import { CellDef } from '../table.interfaces';

@Directive({ selector: '[itrFooterCellDef]' })
export class ItrFooterCellDefDirective implements CellDef {
  constructor(public template: TemplateRef<any>) {}
}
